import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import icon from '../../../assets/images/backoffice/kyc3.png';
import BottomDrawer from '../../../components/common/BottomDrawer';
import { H2, H3, InputLabel, P1, P2 } from '../../../styles/FontStyles';
import { ArrowPolygon, Button, Select } from '../../../styles/GlobalComponents';
import { useWindowWide } from '../../../helpers/wideScreen';
import { Desktop, Mobile, TitleImage } from '../KycStyled';
import { addKycDocument } from './KycDocuments.actions';
import { AnimatedDashboard, ErrorToast } from '../../../components';
import Spinner from '../../../components/common/Spinner';

const KycDocuments = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('kyc');
  const [select, setSelect] = useState('id');
  const [type, setType] = useState(1);
  const [documentHolder, setDocumentHolder] = useState('');

  const PassID = [
    { name: t('document_details.id_option'), value: 'id', id: 1 },
    {
      name: t('document_details.driver_license_option'),
      value: 'license',
      id: 2
    },
    { name: t('document_details.passport_option'), value: 'passport', id: 3 }
  ];
  const [isVisible3, setIsVisible3] = useState(false);
  const onClose3 = useCallback(() => {
    setIsVisible3(false);
  }, []);

  const dispatch = useAppDispatch();
  const userInfo = useAppSelector((state) => state.auth.userInfo);
  const { loading } = useAppSelector((state) => state.kyc);
  const { kycStatus, user } = userInfo;

  function handleSelect(val: any) {
    setType(val.id);
    setSelect(val.value);
    setIsVisible3(false);
  }

  const GoNext = () => {
    // localStorage.setItem('document', select);
    if (!documentHolder) {
      ErrorToast(t('document_details.err_add_account_holder_name'));
    } else {
      dispatch(
        addKycDocument({ type, documentHolder: documentHolder.trim(), history })
      );
    }
  };

  useEffect(() => {
    if (user?.name && user?.surname) {
      setDocumentHolder(user?.name.trim() + ' ' + user?.surname.trim());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kycStatus, dispatch]);

  const wide = useWindowWide(1000);

  return (
    <AnimatedDashboard key={'kyc-documents'}>
      {loading && <Spinner fullScreen={true} transparent />}

      <Desktop>
        <TitleImage>
          <img src={icon} alt='icon' style={{ marginBottom: 40, width: 100 }} />
        </TitleImage>
      </Desktop>

      <Desktop>
        <H2 mb='12'>{t('document_details.title')}</H2>

        <P1 mb='40' maxWidth='600px' maxWidthSM='1000px'>
          {t('document_details.subtitle')}
        </P1>
      </Desktop>
      <Mobile>
        <H3 mb='8' center>
          {t('document_details.title')}
        </H3>

        <P2 mb='32' center>
          {t('document_details.subtitle')}
        </P2>
      </Mobile>

      <div style={{ width: '100%', maxWidth: wide ? 333 : '' }}>
        <InputLabel>{t('document_details.label')}</InputLabel>

        <Select
          style={{ cursor: 'pointer' }}
          onClick={() => setIsVisible3(true)}>
          <div>
            {select === 'id'
              ? t('document_details.id_option')
              : select === 'license'
              ? t('document_details.driver_license_option')
              : t('document_details.passport_option')}
          </div>
          <ArrowPolygon direction={''} />
        </Select>
      </div>
      <Desktop>
        <Button onClick={() => GoNext()} maxWidth='200px'>
          {t('document_details.continue')}
        </Button>
      </Desktop>
      <Mobile>
        <Button onClick={() => GoNext()}>
          {t('document_details.continue')}
        </Button>
      </Mobile>

      <BottomDrawer isVisible={isVisible3} onClose={onClose3}>
        {Object.values(PassID).map((passId, i) => (
          <div
            key={i}
            onClick={() => handleSelect(passId)}
            className='mb-20'
            style={{ cursor: 'pointer' }}>
            {passId.name}
          </div>
        ))}
      </BottomDrawer>
    </AnimatedDashboard>
  );
};

export default KycDocuments;
